"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _styledSystem = require("styled-system");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../../Box"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _ListContext = _interopRequireDefault(require("./ListContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var listItem = (0, _styledSystem.variant)({
  key: 'listItems'
});
var ListItemEl = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "ListItem__ListItemEl",
  componentId: "t1b7c6-0"
})(["", " &[data-selected=true]{background-color:", ";}", ""], function (props) {
  if (props.onClick || props.href) {
    // hover styles;
    var bg = (0, _themeGet["default"])("colors.".concat(props.hoverColor))(props);
    return "\n        cursor: pointer;\n        &:hover {\n          background-color: ".concat(bg, ";\n        }\n      ");
  }

  return '';
}, function (props) {
  return (0, _themeGet["default"])("colors.".concat(props.selectedColor))(props);
}, listItem);

var ListItem = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      selected = _ref.selected,
      variantProp = _ref.variant,
      props = _objectWithoutProperties(_ref, ["children", "selected", "variant"]);

  var variant;

  var listContext = _react["default"].useContext(_ListContext["default"]);

  if (listContext) {
    variant = listContext.variant;
  }

  return _react["default"].createElement(ListItemEl, _extends({
    ref: ref,
    "data-selected": selected,
    display: "flex",
    alignItems: "center",
    variant: variant || variantProp
  }, props), children);
});

ListItem.defaultProps = {
  theme: _theme["default"],
  variant: 'default',
  hoverColor: 'neutral.100',
  selectedColor: 'neutral.200'
};

var _default = (0, _styledComponents.withTheme)(ListItem);

exports["default"] = _default;